import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-user-nav-left',
  templateUrl: './nav-left.component.html',
  styleUrls: ['./nav-left.component.scss']
})
export class UserNavLeftComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
